export default {
  "推荐": "Embed",
  "推荐到频道": "Recommend",
  "正在生成可选封面图，系统会默认选中第一张作为视频封面": "Generating cover images, first one will be automatically selected",
  "创作时间": "Created Time",
  "品牌 / 甲方": "Brand / Party A",
  "作品介绍": "Intro",
  "纯文字版": "Text",
  "图文并茂版": "Rich Text",
  "中文介绍": "Chinese",
  "英文介绍（选填）": "English（Optional）",
  "英文介绍": "English",
  "图片相册": "Album",
  "+新标签": "+ New",
  "分类和标签": "Categories & Tags",
  "填写更多标签信息，方便您的作品被更多地浏览和准确地筛选到": "More tag info helps to get more views and may be filtered with better precision",
  "类别": "Categories",
  "+ 选择类别标签": "+ Seclect Categories & Tags",
  "选填，最多选择3个": "Optional, 3 at most",
  "最多选择1个": "1 at most",
  "最多选择x个": "{num} at most",
  "应用场景": "Application Scenarios",
  "软硬件及工具": "Softwares, Hardwares & Tools",
  "上一步": "Previous",
  "请选择创作年份": "Please Select Creation Year",
  "作品介绍不能为空": "Work intro is required",
  "编辑标签": "Edit Tags",
  "填写完整的标签信息将有利于您的作品被更多地浏览": "Complete tag info helps to get more presence",
  "软件": "Softwares",
  "硬件": "Hardwares",
  "材料": "Materials",
  "技术手段及其他工具": "Technical Means & Tools",
  "请选择展示条件": "Please select demonstration environment",
  "图片格式": "Image format",

  "拖拽您要上传的视频文件于此": "Drag your video here",
  "或者": " or ",
  "视频支持格式：flv, mpg, mpeg, avi, wmv, mov, asf, rm, rmvb, mkv, mp4": "Supported video format：flv, mpg, mpeg, avi, wmv, mov, asf, rm, rmvb, mkv, mp4",
  "文件大小：3G以内": "Filesize：less than 3G",
  "基本信息": "Basic Info",
  "分类和标签": "Categories & Tags",
  "商业转化": "Business Conversion",
  "年份": "Year",
  "月份(选填)": "Month(Optional)",
  "请仔细考虑此作品是否愿意开放给所有MANA认证用户进行免费下载；下载的视频将会带有MANA的Logo水印和您的MANA账号昵称，这将有利于您的作品在网络传播，被更多人看见。": "Please give it a thought that whether you'd like to allow MANA certified users download this work; downloaded video will be watermaked with MANA logo and your nickname, which helps to broadcast your work and make it accessible to more people.",
  "展示条件": "Demonstration environment",
  "选填，可多选": "Optional, multiple accepted",
  "适用于室内": "For indoors",
  "适用于室外": "For outdoors",
  "适用于线上及虚拟空间": "For online & virtual space",
  "商业合作方式": "Business Cooperation",
  "选填，可多选；以下信息仅用于该作品商业转化的接洽，不会在网站及APP上公开展示，未经创作者确认不会与第三方分享。": "Optional, multiple accepted: the following info is only for business partnership, won't be displayed on our website & apps. The info won't be disclosed to 3rd party without your permisson.",
  "租赁": "For Rent",
  "售卖": "For Sale",
  "请选择价格范围": "Select Price Range",
  "请填写价格或价格范围": "Price Range",
  "定制": "Customize",
  "其他": "Other",
  "请填写其他合作方式": "Fill in other cooperation ways",
  "请选择类别": "Please Select Categories",
  "最多选择5个": "5 at most",
  "请选择此分类下细分标签": "Please Select Subtags",
  "已选择": "Selected",
  "个分类标签": " tags",
  "2万元以下": "Below RMB 20K",
  "0~10万元": "RMB 0~100K",
  "2万元~5万元": "RMB 20K~50K",
  "5万元~10万元": "RMB 50K~100K",
  "10万元~30万元": "RMB 100K~300K",
  "30万元~50万元": "RMB 300K~500K",
  "50万元~100万元": "RMB 500K~1000K",
  "100万元以上": "Above RMB 1000K",
  "自定义价格": "Custom Price",
  "请先完善基本信息": "Please complete basic info",
  "请先完善前面步骤": "Please complete previous steps",
  "审核通过发布前仅发布者自己可以查看作品": "After being reviewed by our team, we will release it to the public.",
  "数量已达到上限，无法选择": "Maximum reached, can't select more",
  "分类": "Categories",
  "回首页": "Home",
  "查看作品": "See works",
  "请确保视频文件在您的电脑设备上可正常播放再进行上传": "Please make sure the video can be played before uploading",
  "数量已达到上限，无法添加": "Maximum reached, can't add more",
  "您所填写的信息尚未保存": "You info hasn't been saved",
  "确定要离开吗？": "Do you really want to exit?",
  "确定": "Confirm",
  "取消": "Cancel",


  "使用硬件": "Hardwares",
  "使用材料": "Materials",
  "技术手段及其他工具": "Technologies & Tools",
  "为您推荐": "Recommended for you",
  "收藏成功": "Success",
  "取消收藏成功": "Success",
  "制作工具": "Equipment",
  "他们也觉得赞": "Also Liked by",
  "还没有成员点赞这件作品哦": "Nobody Has Liked It Yet",
  "成为第一个赞": "Be the First to Like",
  "热门推荐": "Hot",
  "图片相册": "Album",
  "自动播放": "Autoplay",
  "嵌入视频": "Embed",
  "复制代码": "Copy",
  "使用软件": "Software(s)",
  "TA的更多作品": "More Works",
  "即将开始": "Upcoming",
  "画质": "Quality",
  "超高清": "F-HD",
  "高清": "HD",
  "标清": "SD",
  "用户暂未开放该视频下载": "Download unauthorized",
  "请搜索或选择国籍": "Search or select nationality",
  "招聘": "Jobs",
  "后续作品入围后我们将通过邮件和短信告知，敬请留意": "Your entry will be notified with SMS & email!",
  "接下来播放": "Upcoming next",
  "文章详情": "Article Details",
  "上传时间": "Upload Time",
  "广告": "Ad",
  "MANA 全球新媒体艺术平台": "MANA Global New Media Arts Platform",
  "全新版客户端发布 使用更流畅": "The new version, wonderful user experience.",
  "扫码下载APP": "Scan code to download APP",

  "每日推荐": "Recommended",
  "新人必看": "Orientation",
  "最近更新": "Latest",
  "我的关注": "Following",
  "暂无关注的创作者发布的作品，快去关注喜欢的创作者吧！": "ou haven't followed any creators, please go ahead and follow your favorite creators!",
  "发现创作者": "Explore Creators",
  "热门分类": "Hot Categories",
  "更多": "More",
  "热门行业": "Hot Industries",
  "热门应用场景": "Hot Scenarios",
  "活动推荐": "Recommended Events",
  "文章": "Articles",
  "MANA学院": "MANA Academy",
  "入驻高校": "Colleges",
  "精选创作者": "Selected Creators",
  "最新加入创作者": "Newly Joined Creators",
  "精选作品": "Selected Videos",
  "精选文章": "Selected Articles",
  "精选活动": "Selected Events",
  "精选频道": "Selected Channels",
  "直播": "Live",
  "+ 关注": "+ Follow",
  "登录后即可查看关注的作品": "View followed works after logging in",
  "+新增": "+ Add",
  "视频正在转码中，请耐心等待1～2分钟后再尝试": "Video encoding, please try in 1 to 2 minutes",
  "请输入个人简介及获奖经历": "Please enter intro and awards",
  "下载资源包": "Download",
  "请选择场景": "Please select scenes",
  "点击下载所有资料包": "Click to download",
  "点击下载资料包": "Click to download",
  "个点位": " locations",
  "已选择": "Selected",
  "已选资料包下载": "Selected archives",
  "的点位": " location",
  "请选择场景以及点位": "Please select scene & location",
  "是否公开": "Open to public?",
  "公开": "Public",
  "请选择是否公开": "Please choose to keep it public or private",
  "确认信息": "Confirm",
  "请仔细核对所要提交的信息是否正确": "Please double check your submitted info",
  "视频类型": "Video Type",
  "视频是否公开": "Open to public",
  "视频下载": "Download",
  "场景及点位": "Scenes & Locations",
  "我已了解并同意本次活动应征条款": "I've read and approved to the Enrolment Terms",
  "请先同意本次活动应征条款": "Please approve to the Enrolment Terms first",
  "应征条款": "Enrolment Terms",
  "参赛类别最多只能选3个": "3 contest type fields at most",
  "参赛类别最多只能选1个": "1 contest type fields at most",
  "参赛类别最多只能选x个": "{num} contest type fields at most",
  "首选投稿分类": "Primary Category",
  "单选，必填": "Required, 1 category only",
  "次选投稿分类": "Secondary Category",
  "单选，选填": "Optional, 1 category only",
  "首选投稿分类最多只能选1个": "Only 1 category's allowed for primary category",
  "次选投稿分类最多只能选1个": "Only 1 category's allowed for secondary category",
  "已静音播放": "Video muted",
  "点击恢复音量": "click to unmute",
}



// WEBPACK FOOTER //
// ./src/languages/en/video.js